import { connect } from 'react-redux'
import BundleCompare from '../components/BundleCompare/BundleCompare'
import { selectors } from '../../health-bundles'

const mapStateToProps = (state) => ({
  currentGroupFavorites: selectors.getCurrentGroupFavoriteBundles(state),
})

export default connect(mapStateToProps)(BundleCompare)
